import React from "react";
import { ANALYTICS_CATEGORY } from "../../../../helpers/constants";
import TrackedLink from "../../../Analytics/TrackedLink";
import Go from "./Go";
import Add from "./Add";
import Use from "./Use";
import "../index.scss";

const URL = `${process.env.SCOUT_EXT_PRO_NEW}?utm_source=site&utm_medium=amzscout&utm_campaign=es_t`;

const Row = () => {
  return (
    <div className="PgESM-PI__Row">
      <div className="PgESM-PI-tile PgESM-PI-tile_go">
        <div className="PgESM-PI-info">
          <p className="PgESM-PI__num">01</p>
          <p className="PgESM-PI__text">
            Ve a la página de la{" "}
            <TrackedLink
              category={ANALYTICS_CATEGORY.MAIN_PAGE}
              action="CTA"
              target
              classes="PgESM-PI__text PgESM-PI__text_link"
              label="PRO AI Extension for Chrome"
              path={URL}
              showMobileProPopup
            >
              Extensión PRO AI
            </TrackedLink>{" "}
            en la Chrome Store
          </p>
        </div>
        <Go />
      </div>
      <div className="PgESM-PI-tile PgESM-PI-tile_add">
        <div className="PgESM-PI-info">
          <p className="PgESM-PI__num">02</p>
          <p className="PgESM-PI__text">
            Haz clic en el botón "Agregar" y espera 5 segundos
          </p>
        </div>
        <Add />
      </div>
      <div className="PgESM-PI-tile PgESM-PI-tile_use">
        <div className="PgESM-PI-info">
          <p className="PgESM-PI__num">03</p>
          <p className="PgESM-PI__text">
            La Extensión PRO AI de AMZScout se ha añadido a tu navegador Chrome
            o Edge: explora productos en el sitio de Amazon y obtén análisis
            detallados directamente en la página de búsqueda
          </p>
        </div>
        <Use />
      </div>
    </div>
  );
};

export default Row;
